import React from 'react'
import PropTypes from 'prop-types'
import compose from '@shopify/react-compose'
import { withTheme } from 'react-jss'
import { withTranslation } from 'react-i18next'
import classNames from 'classnames'

import styles from './wifi-credentials-style'

const WifiCredentials = props => {
  const classes = styles(props.theme)

  return (
    <div className={classNames(classes.credentials, props.className)}>
      <div className={classNames(classes.credentialsItem)}>
        <span className={classes.credentialsLabel}>{props.t('ran_room.your_psk')}</span>
        <strong className={classes.credentialsValue}>{props.psk}</strong>
      </div>
      {props.ssid &&
        <div className={classNames(classes.credentialsItem)}>
          <span className={classes.credentialsLabel}>{props.t('ran_room.your_network')}</span>
          <strong className={classes.credentialsValue}>{props.ssid}</strong>
        </div>
      }
    </div>
  )
}

WifiCredentials.propTypes = {
  psk: PropTypes.string.isRequired,
  ssid: PropTypes.string,
  theme: PropTypes.object.isRequired,
  className: PropTypes.string,
}

export default compose(
  withTheme,
  withTranslation(),
)(WifiCredentials)
